// extracted by mini-css-extract-plugin
export var dropdownButton = "_17-0";
export var fullWidthDropdownButton = "_17-1";
export var icon = "_17-3";
export var iconPlaceholder = "_17-2";
export var menuItemRow = "_17-8";
export var separator = "_17-c";
export var shortcutContainer = "_17-7";
export var shortcutIconLg = "_17-6";
export var shortcutIconMd = "_17-5";
export var shortcutIconSm = "_17-4";
export var submenuChevron = "_17-b";
export var submenuDropdown = "_17-9";
export var submenuTriggerRow = "_17-a";